import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {
  appPrefix = 'IngsvAdmin';

  setItem(param: string, value: any): void {
    if (localStorage) {
      localStorage.setItem(`${this.appPrefix}-${param}`, value);
    }
  }

  setObject(param: string, value: any): void {
    if (localStorage) {
      localStorage.setItem(
        `${this.appPrefix}-${param}`,
        JSON.stringify(value)
      );
    }
  }

  getItem(param: string): any {
    return localStorage ? localStorage.getItem(`${this.appPrefix}-${param}`) : '';
  }

  removeItem(param: string): any {
    if (localStorage) {
      localStorage.removeItem(`${this.appPrefix}-${param}`);
    }
  }

  clear(): void {
    if (localStorage) {
      localStorage.clear();
    }
  }
}
